import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";

import { FormControlLabel } from "../../Default/LekUI/Checkbox";
import Filter from "./DefaultFilters";

export default function CemVersionsFilter(props) {
	const { t } = useTranslation();
	const setSelectedVersion = (value) => {
		if (props.selectedData.cemVersions.includes(value)) {
			return props.setSelectedData({
				cemVersions: props.selectedData.cemVersions.filter(
					(version) => version !== value,
				),
			});
		}

		return props.setSelectedData({
			cemVersions: [...props.selectedData.cemVersions, value],
		});
	};

	const renderVersion = () => {
		return props.cemVersions.map((version) => {
			return (
				<div className="p-relative" key={version.cem_version}>
					<FormControlLabel
						value={version.cem_version}
						label={version.label}
						onChange={() => setSelectedVersion(version.cem_version)}
						checked={props.selectedData.cemVersions.includes(
							version.cem_version,
						)}
						Control={<Checkbox />}
					/>
				</div>
			);
		});
	};

	const renderFilters = () => {
		return <div className="flex gap-8">{renderVersion()}</div>;
	};

	return (
		<Filter
			{...props}
			hint={t("filters.exams.cemVersions.hint")}
			title={t("filters.exams.cemVersions.title")}
			renderFilterDetails={renderFilters}
		/>
	);
}
